import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setSelectedProduct } from '../../redux/user-selection/userSelection';
import './Package.css';

interface OwnProps {
  productId: number;
}

const Package: React.FC<OwnProps> = ({ productId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = () => {
    dispatch(setSelectedProduct({ productId }));
    navigate('/pickup');
  };

  return (
    <div className="package-container" data-testid={`package-${productId}`}>
      <h2 className="padding-left" id={`package-${productId}-name`}>
        Educate 'Essential Driving' Package
      </h2>
      <div className="package-main-info">
        <p className="text__center">
          For new learner permit holders wishing to fulfil the Essential Driver Training requirement
        </p>
        <p className="package-include-text">
          <strong>What's included</strong>
        </p>
        <ul className="package-container-list">
          <li id={`package-${productId}-lessons`}>
            12 Essential Driver Training lessons <span className="checkmark">&#10003;</span>
          </li>
          <li>
            6 months accompanied driver cover* <span className="checkmark">&#10003;</span>
          </li>
        </ul>
      </div>
      <p className="package-callout">
        If you have a gift voucher, please call <span className="text__nowrap">1800 663663</span>
      </p>
      <button className="a-button a-button--primary" onClick={handleClick}>
        Buy now
      </button>
    </div>
  );
};

export default Package;